import { render } from "./VisitingReservationFinish.vue?vue&type=template&id=2686d680"
import script from "./VisitingReservationFinish.vue?vue&type=script&lang=js"
export * from "./VisitingReservationFinish.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__